import { render, staticRenderFns } from "./FolderSideMenuPage.vue?vue&type=template&id=262f5a06&scoped=true"
import script from "./FolderSideMenuPage.vue?vue&type=script&lang=ts"
export * from "./FolderSideMenuPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262f5a06",
  null
  
)

export default component.exports